// @ts-nocheck

import React, { useCallback, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useMergeProps from '../../../hooks/useMergeProps';
import { claimGRReward } from '../actions/gr';
import GRRoundCompleteNotification from '../components/common/GRRoundCompleteNotification';
import useGRHomeContext from '../hooks/useGRHomeContext';
import selectGRRoundCompleteNotificationProps from '../selectors/specifics/selectGRRoundCompleteNotificationProps';
import { GRFullScreenNotifications } from '../types/notification';

type GRRoundCompleteNotificationTriggererProps = {
  className?: string;
};

const GRRoundCompleteNotificationTriggerer = (ownProps: GRRoundCompleteNotificationTriggererProps) => {
  const { setFullScreenNotifShown } = useGRHomeContext();

  const dispatch = useDispatch();

  const { show, notificationId, ...selectedProps } = useSelector(selectGRRoundCompleteNotificationProps);

  useEffect(() => {
    if (show) {
      setFullScreenNotifShown(GRFullScreenNotifications.ROUND_COMPLETE);
    }
  }, [setFullScreenNotifShown, show]);

  const onClaimRewardClick = useCallback(() => {
    dispatch(claimGRReward({ uuid: notificationId }));
    setFullScreenNotifShown(null);
  }, [dispatch, setFullScreenNotifShown, notificationId]);

  const otherProps = useMemo(
    () => ({
      onClaimRewardClick,
    }),
    [onClaimRewardClick],
  );

  const enhancedProps = useMergeProps({ ownProps, selectedProps, otherProps });

  return <GRRoundCompleteNotification {...enhancedProps} />;
};

export default GRRoundCompleteNotificationTriggerer;
